module.exports = __webpack_public_path__ + "static/media/clients.14c091d8.png";